import { render } from "./ReqTypeDonutChart.vue?vue&type=template&id=3f62f380&scoped=true"
import script from "./ReqTypeDonutChart.vue?vue&type=script&lang=js"
export * from "./ReqTypeDonutChart.vue?vue&type=script&lang=js"

import "./ReqTypeDonutChart.vue?vue&type=style&index=0&id=3f62f380&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f62f380"]])

export default __exports__